"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tracking = exports.SELECTOR_TYPES = void 0;
const tslib_1 = require("tslib");
const package_json_1 = tslib_1.__importDefault(require("../../package.json"));
const connection_aem_tracking_1 = require("@owc/connection-aem-tracking");
const logger_1 = require("./logger");
const VMDSModule_1 = require("@/store/modules/vmds/VMDSModule");
const store_1 = tslib_1.__importDefault(require("@/store"));
const utils_1 = require("@/store/modules/vehicleSelector/utils");
var SELECTOR_TYPES;
(function (SELECTOR_TYPES) {
    SELECTOR_TYPES["CLASS"] = "class_selector";
    SELECTOR_TYPES["BODY_TYPE"] = "bodytype_selector";
    SELECTOR_TYPES["MOTORISATION"] = "motorisation_selector";
})(SELECTOR_TYPES || (exports.SELECTOR_TYPES = SELECTOR_TYPES = {}));
class TrackingManager {
    /**
     * Constructor
     */
    constructor() {
        /**
         * Class attributes
         */
        this.EVENT_ID = 'click';
        this.APPLICATION_ID = 'fcis-widget';
        this.APPLICATION_PARENT_ID = 'aem';
        this.ACTION_ID = 'finance_calculator';
        this.cleoStatus = 'loading';
        this._version = package_json_1.default.version;
    }
    setCleoStatus(status) {
        this.cleoStatus = status;
    }
    /**
     * Methods
     */
    /**
     * initialize: Should be fired once the page is first visible.
     * @returns {void}
     */
    initialize() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const waitForCleoStatus = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                while (this.cleoStatus === 'loading') {
                    console.log('Waiting for cleo status...');
                    yield new Promise((resolve) => setTimeout(resolve, 1000));
                }
            });
            yield waitForCleoStatus();
            this.publish({
                category: 'impression',
                label: this.cleoStatus,
                name: this.cleoStatus === 'success' ? 'impression' : 'system_error',
            });
        });
    }
    /**
     * update: Fired every time the input fields are updated
     * @param {string} name - Event trigger field's name
     * @param {string} errorType - Error type: errorCode:string
     * @returns {void}
     */
    update(name, errorType) {
        const payload = {
            category: 'feature',
            label: name,
            name: 'feature',
        };
        if (errorType) {
            payload.errorType = errorType;
        }
        this.publish(payload);
    }
    /**
     * selectOption: Fired every time a selection inside of
     * the vehicle selector is made
     * @param {SELECTOR_TYPES} selectorType
     */
    selectOption(selectorType, variant) {
        const payload = {
            category: 'feature',
            label: `${selectorType}${variant ? '.' + variant : ''}`,
            name: 'select_option',
        };
        this.publish(payload);
    }
    /**
     * action: Fired every time a button is clicked
     * @param {string} name - Button's name
     * @param {string} category - Event's category
     * @param {string} action - Event's action
     * @returns {void}
     */
    action(name_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function* (name, category = 'link', action) {
            yield this.publish(Object.assign(Object.assign({ category, label: name }, (action !== undefined ? { action } : {})), (category === 'link' ? { name: 'link' } : {})));
        });
    }
    /**
     * publish: method responsible to publish events to the EMB
     * service
     * @param data - TrackingManager methods payload
     * @returns {void}
     */
    publish(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            const { defaultCustomerType, defaultFinancingProduct } = (_a = store_1.default === null || store_1.default === void 0 ? void 0 : store_1.default.state) === null || _a === void 0 ? void 0 : _a.app;
            let state = '';
            if (defaultCustomerType && defaultFinancingProduct) {
                state = `${defaultCustomerType.toLowerCase()}|${defaultFinancingProduct.toLowerCase()}`;
            }
            // Wait until baumuster and productGroup are populated
            const waitForVehicleData = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                while (!((_b = (_a = VMDSModule_1.VMDSModule === null || VMDSModule_1.VMDSModule === void 0 ? void 0 : VMDSModule_1.VMDSModule.state) === null || _a === void 0 ? void 0 : _a.currentVehicle) === null || _b === void 0 ? void 0 : _b.baumuster) || !((_d = (_c = VMDSModule_1.VMDSModule === null || VMDSModule_1.VMDSModule === void 0 ? void 0 : VMDSModule_1.VMDSModule.state) === null || _c === void 0 ? void 0 : _c.currentVehicle) === null || _d === void 0 ? void 0 : _d.productGroup)) {
                    yield new Promise((resolve) => setTimeout(resolve, 100)); // Poll every 100ms
                }
            });
            yield waitForVehicleData();
            const trackingData = {
                application: {
                    id: this.APPLICATION_ID,
                    version: this._version,
                    parentApplicationId: this.APPLICATION_PARENT_ID,
                },
                event: this.EVENT_ID,
                eventDetail: Object.assign(Object.assign(Object.assign({ action: this.ACTION_ID }, data), { vehicle: {
                        baumusterId: (_c = (_b = VMDSModule_1.VMDSModule === null || VMDSModule_1.VMDSModule === void 0 ? void 0 : VMDSModule_1.VMDSModule.state) === null || _b === void 0 ? void 0 : _b.currentVehicle) === null || _c === void 0 ? void 0 : _c.baumuster,
                        type: (0, utils_1.vehicleDivision)((_e = (_d = VMDSModule_1.VMDSModule === null || VMDSModule_1.VMDSModule === void 0 ? void 0 : VMDSModule_1.VMDSModule.state) === null || _d === void 0 ? void 0 : _d.currentVehicle) === null || _e === void 0 ? void 0 : _e.productGroup),
                    } }), (state
                    ? {
                        state,
                    }
                    : {})),
            };
            console.log('%cNew tracking event:', 'color: green; background: yellow;', Object.assign({}, trackingData));
            try {
                const eventDispatchers = yield (0, connection_aem_tracking_1.getTrackingDispatchers)();
                eventDispatchers.pushTrackingEvent(trackingData);
            }
            catch (err) {
                logger_1.logger.info(err);
            }
        });
    }
}
/**
 * Create a new singleton
 */
exports.tracking = new TrackingManager();
